import type { AllocationPeriodUi } from "../types/time-allocation.ts";

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function parseIsoDate(iso: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso.trim());
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]) - 1;
  const d = Number(m[3]);
  const dt = new Date(y, mo, d);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

function isoWeekNumber(date: Date): number {
  const d = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
  );
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(
    ((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7,
  );
}

export function periodDisplayName(period: AllocationPeriodUi): string {
  if (period === "MONTHLY") return "monthly";
  if (period === "WEEKLY") return "weekly";
  return "custom";
}

export function formatAllocationCurrentLabel(
  period: AllocationPeriodUi,
  allocationDateIso?: string,
  customStartIso?: string,
  customEndIso?: string,
): string | null {
  if (period === "CUSTOM") {
    const s = customStartIso ? parseIsoDate(customStartIso) : null;
    const e = customEndIso ? parseIsoDate(customEndIso) : null;
    if (s && e) {
      const sm = MONTH_NAMES[s.getMonth()];
      const em = MONTH_NAMES[e.getMonth()];
      const sy = s.getFullYear();
      const ey = e.getFullYear();
      const sd = s.getDate();
      const ed = e.getDate();
      if (sy === ey && s.getMonth() === e.getMonth()) {
        return `Current: ${sm} ${sd} – ${ed}, ${sy}`;
      }
      return `Current: ${sm} ${sd}, ${sy} – ${em} ${ed}, ${ey}`;
    }
    const ref = allocationDateIso ? parseIsoDate(allocationDateIso) : null;
    if (ref) {
      const m = MONTH_NAMES[ref.getMonth()];
      return `Current: ${m} ${ref.getDate()}, ${ref.getFullYear()}`;
    }
    return null;
  }

  const ref = allocationDateIso ? parseIsoDate(allocationDateIso) : null;
  if (!ref) return null;

  if (period === "MONTHLY") {
    return `Current: ${MONTH_NAMES[ref.getMonth()]} ${ref.getFullYear()}`;
  }

  const w = isoWeekNumber(ref);
  const m = MONTH_NAMES[ref.getMonth()];
  return `Current: Week ${w} (${m} ${ref.getDate()}, ${ref.getFullYear()})`;
}
